import { EnvService } from "./env.service";
import { environment } from "src/environments/environment";

export interface TenantInfo {
  clientId: string;
  tenantId: string;
  ciamSubdomain?: string; // CIAM tenant subdomain (e.g. "invoiceconarmac")
}

const CACHE_KEY = "invoicecon_tenant_info";

/**
 * Utility class — purely static, no Angular DI involved.
 * Data is fetched via native fetch() before bootstrapping (see main.ts)
 * and read synchronously via getCached() in MSAL config factories.
 */
export class TenantInfoService {
  static getCached(): TenantInfo | null {
    try {
      const raw = sessionStorage.getItem(CACHE_KEY);
      return raw ? (JSON.parse(raw) as TenantInfo) : null;
    } catch {
      return null;
    }
  }

  static async prefetch(): Promise<void> {
    try {
      const group = EnvService.cliente;
      const offset = new Date().getTimezoneOffset();
      const response = await fetch(`${environment.api_endpoint}/api/v2/cliente/${group}/tenant-info`, {
        headers: {
          'ambiente': EnvService.ambienteHeader,
          'cliente': group,
          'timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
          'timezone-offset': (offset > 0 ? '-' : '') + String(Math.abs(offset)),
        },
      });
      if (response.ok) {
        const info: TenantInfo = await response.json();
        if (info?.clientId || info?.tenantId) {
          sessionStorage.setItem(CACHE_KEY, JSON.stringify(info));
        }
      }
    } catch { /* fall back to environment defaults */ }
  }
}
